import BundledProductList from './BundledProductList';

export default BundledProductList;
